import moment from 'moment';
import CardInfoIcon from '../../../assets/images/CardIcon.svg';

export const CardInfo = ({ data }) => {
  console.log(data);
  return (
    <div className="flex w-full items-center justify-center gap-4 h-full flex-col p-5">
      <div className="flex flex-row w-full h-full items-center justify-between">
        <div className="flex h-full  items-center flex-row gap-2">
          <div className="size-14 flex items-center justify-center  rounded-full">
            <img
              src={CardInfoIcon}
              alt="carPoint"
              className="object-contain size-full"
            />
          </div>
          <div className="flex items-center   text-sm flex-col">
            <div className="w-full text-left">
              {data?.employee?.id} {data?.employee?.user?.firstname}{' '}
              {data?.employee?.user?.lastname}
            </div>
            <div className="w-full text-left text-gray-500 italic">
              Kart No: {data.card.id}
            </div>
          </div>
        </div>
      </div>
      <div className="flex text-left flex-row gap-3 justify-between w-full text-sm">
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Sürücü</div>
          <div className="w-full">
            {data.driver.firstname} {data.driver.lastname}
          </div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Araç Plakası</div>
          <div className="w-full">{data.vehicle.id}</div>
        </div>

        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Görev Adı</div>
          <div className="w-full">
            {data?.transportation?.transportation?.content}
          </div>
        </div>
        <div className="flex flex-col items-center text-left justify-center ">
          <div className="text-xs w-full  text-gray-500">Tarih ve Saat</div>
          <div className="w-full">
            {moment(data.time).format('DD.MM.YYYY HH:MM')}
          </div>
        </div>
      </div>
    </div>
  );
};
